import { Box, BoxProps } from "@mui/material";

const CustomizedBoxTable = ({ children, height, ...props }: BoxProps) => {
  return (
    <Box
      sx={{
        height: height ?? "calc(90vh - 270px)",
        "& .ag-floating-filter-body": {
          position: "relative",
          margin: 0,
          width: "100%",
        },
        "& .ag-header-cell .ag-floating-filter-button": {
          margin: 0,
          transition: "visibility 0s, opacity 0.3s ease",
          opacity: 0,
        },
        "& .ag-header-cell:hover .ag-floating-filter-button": {
          opacity: 1,
        },
        "& .ag-header-cell": {
          paddingLeft: "10px",
          paddingRight: "10px",
        },
        "& .ag-cell": {
          paddingLeft: "10px",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default CustomizedBoxTable;
